<template>
  <div class="card-table mb-5" :class="mode ? 'cardtable__day' : 'cardtable__night'">
            <div class="workers-info-title-za">
                <div class="title">{{$t("message.bonuses")}}</div>
            </div>

            <div class="m-3">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="refa__chart">
                            <el-card class="box-card bg-light-primary" :class="mode ? '' : 'text-warning__night'">
                                <i
                                    class="my-icon el-icon-tickets text-primary"
                                ></i>
                                <div class="mobile__izn">
                                  <div class="text-center">
                                    <span class="text-primary">
                                        {{$t("message.total_qty")}}
                                    </span>
                                  </div>
                                  <div class="text-center mt-3">
                                      <b class="text-primary">{{list.length}}</b>
                                  </div>
                                </div>
                            </el-card>
                        </div>
                    </el-col>

                    <el-col :span="24">
                        <div class="scrol-table crmhome__scroll">
                            <table
                                :class="mode ? 'table__myday' : 'table__mynight'"
                                class="
                                    table__layout
                                    table-my-code table-bordered
                                    my-table-card my-clendar
                                "
                            >
                                <thead>
                                    <tr>
                                        <th class="w50p" scope="col">{{$t("message.n")}}</th>
                                        <th scope="col">{{$t("message.date_time")}}</th>
                                        <th scope="col">{{$t("message.amount")}}</th>
                                        <th scope="col">{{$t("message.reason")}}</th>
                                        <th scope="col">{{$t("message.comment")}}</th>
                                        <th scope="col">{{$t("message.responsible")}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(bonuse, index) in list"
                                    :key="'additional-' + index">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ bonuse.created_at }}</td>
                                        <td>{{bonuse.amount}}
                                          </td>
                                          <td>  {{
                                                    bonuse.reason
                                                      ? bonuse.reason.name: ""
                                                  }}
                                          </td>
                                        <td>
                                          {{
                                            bonuse.comment
                                          }}  
                                        </td>
                                        <th>
                                          <div v-if="bonuse.reason&&bonuse.reason.managers">
                                            <span  v-for="manager in bonuse.reason.managers" :key="manager.id">
                                              {{manager.name}} {{manager.last_name}},
                                            </span>
                                          </div>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
</template>
<script>
import { i18n } from "@/utils/i18n";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name:'additional-work',
  props: {
      staff_id: {
        type: Number,
      },
    },

  data() {
    return {
      additionals:{},
    };
  },
  mounted() {
    this.table();
  },
  computed: {
    ...mapGetters({
      list: "profile/staff_bonuses",
      mode: "MODE"
    }),
    actions: function () {
      return ["edit", "delete"];
    },
  },
  methods: {
    ...mapActions({
      updateList: "profile/getBonuses",
    }),

     table(){
      const query = { staff_id: this.staff_id};
      this.updateList(query).then((res) => {
        this.bonuses = res.data.result.data.bonuses;
      });
    },
  }
}
</script>
